import { formatToPhoneNumber } from 'src/components/FormattedPhoneInput/format-to-phone-number';

/**
 * Formats a dialable support phone and optionally appends ` Ext. {n}`.
 * Always formats the base number first — never pass a combined Ext string
 * through formatToPhoneNumber (it mangles non-digit characters).
 */
export function formatSupportPhoneWithExt(
  phone: number | string | null | undefined,
  ext?: number | string | null,
): string {
  if (phone === null || phone === undefined || phone === '') {
    return '';
  }

  const formatted = formatToPhoneNumber(String(phone).replace(/\D/g, ''));
  if (ext === null || ext === undefined || ext === '') {
    return formatted;
  }

  return `${formatted} Ext. ${ext}`;
}
